import { Component, ViewContainerRef, Input } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

import { PaymentComponent } from './../payment/payment.component';

import { PaymentModel } from 'app/shared/models/payment.model';

import { PaymentService } from './../payment.service';

@Component({
    selector: 'app-payment-list',
    templateUrl: './payment-list.component.html'
})

/**
 * Component to display the payment list.
 */
export class PaymentListComponent {
    dialogRef: MdDialogRef<any>;
    payments: PaymentModel[];
    selectedData: Object;
    selectedPayment: PaymentModel;
    isPaymentListLoaded = false;

    constructor(
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
        private paymentService: PaymentService,
        private warmUpService: WarmUpService,
        private snackBarService: SnackBarService,
        private trackingService: TrackingService
    ) { }

    @Input() status: String;
    @Input() transactionStatus: ApplicationValue[];

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }

    deletePayment(payment: PaymentModel) {
        if (confirm(MessageService.DELETE_PAYMENT_ALERT)) {
            this.paymentService.deletePayment(payment.id)
                .subscribe(response => {
                    if (response.flagResult) {
                        this.payments.splice(this.payments.indexOf(payment), 1);
                    }
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.PAYMENTS,
                        TrackingConstants.DELETE_PAYMENT,
                        TrackingConstants.SUCCESS, 1);
                    this.callSnackBarService(response,
                        MessageService.DELETE_PAYMENT_SUCCESS, MessageService.DELETE_PAYMENT_FAILURE);
                },
                err => {
                    this.trackingService
                        .emitEvent(
                        TrackingConstants.PAYMENTS,
                        TrackingConstants.DELETE_PAYMENT,
                        TrackingConstants.FAILURE, 0);
                    this.callSnackBarService(err,
                        MessageService.DELETE_PAYMENT_SUCCESS,
                        MessageService.DELETE_PAYMENT_FAILURE);
                });
        }
    }

    editPayment(selectedPayment: PaymentModel): void {
        const action = 'Edit';
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;

        this.dialogRef = this.dialog.open(PaymentComponent, config);
        this.dialogRef.componentInstance.selectedPayment = selectedPayment;
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(response => {
            this.dialogRef = null;
            if (response) {
                this.paymentService.emitUpdatePaymentLists();
            }
            this.selectedPayment = null;
        });
    }

    getStatusValue(statusId: number) {
        let name = '';
        this.transactionStatus.forEach((transactionStatus, index) => {
            if (transactionStatus.id === statusId) {
                name = transactionStatus.name;
            }
        });
        return name;
    }

    updatePaymentList(status: any) {
        this.paymentService.getPaymentsList(status)
            .subscribe(payments => { 
                this.isPaymentListLoaded = true;
                this.payments = payments; 
            });
            this.isPaymentListLoaded = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/finance/payments/paymentlist/payment-list.component.ts